export { default } from "bullitttime-embercomponents/services/error-manager";
